import React, { useEffect, useState } from 'react';
import { Loader2, Radar, Swords, X, Crown, Users, Wrench, UserPlus, Check } from 'lucide-react';
import { GbCoin } from './GbCoin';
import { GbClanBadge } from './GbClanBadge';

const mmss = (s) => `${String(Math.floor(s / 60)).padStart(2, '0')}:${String(s % 60).padStart(2, '0')}`;

const Card = ({ m, eu, podeConvidar, convidado, onInvite, onCancelInvite }) => (
  <div data-testid={`gb-room-member-${m.kako_id}`}
    className={`relative flex w-[122px] flex-none flex-col items-center gap-1.5 rounded-2xl border-2 px-2 py-3 transition-all ${
      m.searching
        ? 'border-amber-400 bg-amber-950/30 shadow-[0_0_24px_rgba(251,191,36,.35)]'
        : eu ? 'border-orange-500/70 bg-orange-950/25' : 'border-purple-800/60 bg-black/40'}`}>
    {eu && (
      <span className="absolute -top-2 left-1/2 -translate-x-1/2 rounded-full bg-orange-500 px-2 text-[9px] font-black text-[#1b0d02]">
        VOCÊ
      </span>
    )}
    <div className="relative">
      {m.avatar
        ? <img src={m.avatar} alt="" className="h-12 w-12 rounded-full border-2 object-cover"
          style={{ borderColor: m.hex || 'rgba(251,191,36,.6)' }} />
        : <span className="flex h-12 w-12 items-center justify-center rounded-full border-2 border-amber-500/50 bg-purple-900 text-lg">🎃</span>}
      {m.searching && (
        <span className="absolute inset-0 animate-ping rounded-full border-2 border-amber-400/70" />
      )}
      {m.in_match && (
        <span className="absolute -bottom-1 -right-1 flex h-5 w-5 items-center justify-center rounded-full bg-rose-600 text-[9px]">
          <Swords className="h-3 w-3 text-white" />
        </span>
      )}
    </div>
    <p className="w-full truncate text-center text-[11px] font-black text-amber-100">{m.nickname}</p>
    <GbClanBadge clan={{ name: m.clan_name || m.clan, medal_img: m.medal_img, hex: m.hex }}
      size="xs" className="max-w-full" />
    <span className="text-[9px] font-bold text-purple-300/60">Nv {m.level}</span>
    {m.searching
      ? <span className="flex items-center gap-1 rounded-full bg-amber-400/20 px-2 py-[2px] text-[8px] font-black uppercase tracking-wider text-amber-300">
        <Radar className="h-2.5 w-2.5 animate-spin" />combinando
      </span>
      : m.in_match
        ? <span className="rounded-full bg-rose-500/20 px-2 py-[2px] text-[8px] font-black uppercase tracking-wider text-rose-300">em duelo</span>
        : <span className="rounded-full bg-purple-500/15 px-2 py-[2px] text-[8px] font-black uppercase tracking-wider text-purple-300/70">na sala</span>}

    {/* convite direto: chama este jogador para duelar agora, sem passar pela fila */}
    {!eu && !m.in_match && (
      convidado ? (
        <button onClick={() => onCancelInvite?.(m.kako_id)} data-testid={`gb-room-invite-cancel-${m.kako_id}`}
          className="mt-0.5 flex w-full items-center justify-center gap-1 rounded-full border border-amber-500/70 bg-amber-950/50 px-2 py-1 text-[8px] font-black uppercase tracking-wider text-amber-300 transition-colors hover:border-rose-500 hover:text-rose-200">
          <Loader2 className="h-2.5 w-2.5 animate-spin" />convidado
        </button>
      ) : (
        <button onClick={() => onInvite?.(m.kako_id)} disabled={!podeConvidar}
          data-testid={`gb-room-invite-${m.kako_id}`}
          className="mt-0.5 flex w-full items-center justify-center gap-1 rounded-full border border-orange-500/70 bg-orange-600/20 px-2 py-1 text-[8px] font-black uppercase tracking-wider text-orange-200 transition-all hover:bg-orange-500/35 hover:text-amber-100 active:scale-95 disabled:opacity-35 disabled:hover:bg-orange-600/20">
          <UserPlus className="h-2.5 w-2.5" />convidar
        </button>
      )
    )}
  </div>
);

export const GbRoom = ({ room, meuId, buscando, restante, entrada, saldoOk, travado, avisoTrava,
  convite, enviados, onInvite, onCancelInvite, onAcceptInvite, onDeclineInvite,
  onFind, onCancel, onLeave }) => {
  const membros = room?.members || [];
  const buscandoN = membros.filter((m) => m.searching).length;
  const total = Number(room?.search_seconds || 120);
  const pct = Math.max(0, Math.min(100, Math.round((Number(restante || 0) / total) * 100)));
  const convidados = (enviados || []).map((x) => x.kako_id);
  const podeConvidar = !travado && !!saldoOk && !buscando;
  const [restaConvite, setRestaConvite] = useState(0);

  // conta o tempo que o convite recebido ainda tem de pé
  useEffect(() => {
    if (!convite) { setRestaConvite(0); return undefined; }
    setRestaConvite(Number(convite.seconds || 30));
    const id = setInterval(() => setRestaConvite((v) => (v > 0 ? v - 1 : 0)), 1000);
    return () => clearInterval(id);
  }, [convite]);

  return (
    <div className="pwa-safe-top fixed inset-0 z-[65] overflow-y-auto overscroll-contain bg-[#0b0712]"
      style={{ backgroundImage: 'radial-gradient(circle at 50% -10%, rgba(255,107,0,.22), transparent 55%), radial-gradient(circle at 10% 100%, rgba(138,43,226,.22), transparent 50%)' }}
      data-testid="gb-room-page">
      <div className="mx-auto my-auto flex min-h-full max-w-2xl flex-col justify-center px-3 py-5">
    <div className="overflow-hidden rounded-3xl border border-purple-800/60 bg-gradient-to-br from-[#1a1028] via-[#120a1d] to-black shadow-[0_0_60px_rgba(0,0,0,.7)]"
      data-testid="gb-room">
      <div className="flex items-center gap-2 border-b border-purple-900/70 px-4 py-3">
        <span className="relative flex h-8 w-8 items-center justify-center rounded-full border border-amber-600/60 bg-amber-950/40">
          <Radar className="h-4 w-4 text-amber-300" />
          <span className="absolute inset-0 animate-ping rounded-full border border-amber-500/40" />
        </span>
        <div className="min-w-0 flex-1">
          <p className="text-xs font-black uppercase tracking-widest text-amber-300">sala de combinação</p>
          <p className="text-[11px] text-purple-300/70" data-testid="gb-room-count">
            {membros.length} na sala · {buscandoN} buscando oponente
          </p>
        </div>
        <button onClick={onLeave} data-testid="gb-pvp-leave-room"
          className="flex flex-none items-center gap-1 rounded-full border border-purple-700/60 px-3 py-1.5 text-[10px] font-black text-purple-200 transition-colors hover:border-rose-600 hover:text-rose-200">
          <X className="h-3 w-3" />SAIR
        </button>
      </div>

      <div className="px-4 py-3">
        {membros.length === 0 ? (
          <p className="flex items-center justify-center gap-2 py-6 text-xs text-purple-300/60" data-testid="gb-room-empty">
            <Users className="h-4 w-4" />Você é o primeiro na sala — chame a galera!
          </p>
        ) : (
          <div className="flex gap-2 overflow-x-auto pb-1 pt-3" data-testid="gb-room-carousel">
            {membros.map((m) => (
              <Card key={m.kako_id} m={m} eu={m.kako_id === meuId}
                podeConvidar={podeConvidar}
                convidado={convidados.includes(m.kako_id)}
                onInvite={onInvite} onCancelInvite={onCancelInvite} />
            ))}
          </div>
        )}
        {membros.length > 1 && (
          <p className="mt-2 text-center text-[10px] text-purple-300/60" data-testid="gb-room-invite-hint">
            Quer duelar com alguém específico? Toque em <b className="text-orange-300">CONVIDAR</b> no
            card dele — se aceitar, o duelo começa na hora.
          </p>
        )}
      </div>

      <div className="border-t border-purple-900/70 px-4 py-4">
        {buscando ? (
          <div className="flex flex-col items-center gap-3" data-testid="gb-pvp-searching">
            <div className="relative flex h-24 w-24 items-center justify-center">
              <svg viewBox="0 0 100 100" className="absolute inset-0 -rotate-90">
                <circle cx="50" cy="50" r="44" fill="none" stroke="rgba(147,51,234,.25)" strokeWidth="7" />
                <circle cx="50" cy="50" r="44" fill="none" stroke="#fbbf24" strokeWidth="7" strokeLinecap="round"
                  strokeDasharray={`${(pct / 100) * 276} 276`} />
              </svg>
              <span className="font-mono text-lg font-black text-amber-200" data-testid="gb-pvp-countdown">
                {mmss(Math.max(0, Number(restante || 0)))}
              </span>
            </div>
            <p className="flex items-center gap-2 text-xs font-black uppercase tracking-wider text-amber-300">
              <Radar className="h-3.5 w-3.5 animate-spin" />procurando oponente na sala…
            </p>
            <p className="text-[11px] text-purple-300/60">
              Se ninguém combinar em 2 minutos, a busca é cancelada e nada é cobrado.
            </p>
            <button onClick={onCancel} data-testid="gb-pvp-cancel"
              className="rounded-full border border-purple-700/60 px-5 py-2 text-xs font-black text-purple-200 transition-colors hover:border-rose-600 hover:text-rose-200">
              CANCELAR COMBINAÇÃO
            </button>
          </div>
        ) : (
          <div className="flex flex-col items-center gap-2">
            {travado && (
              <div className="mb-1 w-full rounded-2xl border-2 border-amber-500/70 bg-amber-950/50 px-3 py-2.5 text-center"
                data-testid="gb-pvp-maintenance">
                <p className="flex items-center justify-center gap-1.5 text-[10px] font-black uppercase tracking-[0.2em] text-amber-400">
                  <Wrench className="h-3.5 w-3.5" />manutenção programada
                </p>
                <p className="mt-1 text-xs font-bold leading-snug text-amber-100">
                  {avisoTrava || 'As combinações estão pausadas e voltam em breve.'}
                </p>
                <p className="mt-1 text-[11px] text-amber-200/70">
                  As partidas que já começaram seguem até o fim, com prêmio normal.
                </p>
              </div>
            )}
            <button onClick={onFind} disabled={!saldoOk || travado} data-testid="gb-pvp-find"
              className="flex w-full items-center justify-center gap-2 rounded-2xl bg-gradient-to-r from-orange-600 via-orange-500 to-amber-400 px-6 py-4 text-sm font-black uppercase tracking-wide text-[#1b0d02] shadow-[0_0_30px_rgba(255,107,0,.4)] transition-transform hover:scale-[1.02] disabled:opacity-40 disabled:shadow-none disabled:hover:scale-100">
              <Swords className="h-5 w-5" />{travado ? 'combinações pausadas' : 'combinar agora'}
            </button>
            <p className="flex items-center gap-1.5 text-[11px] text-purple-300/70">
              {saldoOk ? <>
                <Crown className="h-3.5 w-3.5 text-amber-400" />
                <GbCoin className="h-[1em]" /> {Number(entrada || 0).toLocaleString('pt-BR')} moedas são cobradas só quando o duelo começa
              </> : <span className="font-bold text-rose-300">
                Saldo insuficiente para a entrada de {Number(entrada || 0).toLocaleString('pt-BR')} moedas.
              </span>}
            </p>
          </div>
        )}
      </div>
    </div>
      </div>

      {/* convite recebido: aceitar começa o duelo na hora com quem chamou */}
      {convite && (
        <div className="fixed inset-0 z-[90] flex items-center justify-center bg-black/88 p-4"
          data-testid="gb-invite-modal">
          <div className="w-full max-w-sm overflow-hidden rounded-3xl border-2 border-orange-500/70 bg-gradient-to-b from-[#1d1030] via-[#140a22] to-black shadow-[0_0_60px_rgba(255,107,0,.35)]">
            <div className="flex flex-col items-center gap-2 px-5 pt-6">
              {convite.de?.avatar
                ? <img src={convite.de.avatar} alt="" data-testid="gb-invite-avatar"
                  className="h-20 w-20 rounded-full border-4 border-orange-400 object-cover shadow-[0_0_30px_rgba(255,107,0,.55)]" />
                : <span className="flex h-20 w-20 items-center justify-center rounded-full border-4 border-orange-400 bg-purple-900 text-3xl">🎃</span>}
              <p className="text-[10px] font-black uppercase tracking-[0.24em] text-orange-400">
                desafio direto
              </p>
              <p className="text-center text-lg font-black leading-tight text-amber-100"
                data-testid="gb-invite-nick">
                {convite.de?.nickname || 'Um jogador'}
              </p>
              <GbClanBadge clan={{ name: convite.de?.clan_name || convite.de?.clan,
                medal_img: convite.de?.medal_img, hex: convite.de?.hex }} size="xs" />
              <p className="text-center text-xs font-bold text-purple-200/80">
                te chamou para um duelo 1v1 agora
              </p>
              <p className="flex items-center gap-1.5 text-[11px] text-purple-300/70">
                <GbCoin className="h-[1em]" /> entrada de {Number(entrada || 0).toLocaleString('pt-BR')} moedas
                · cobrada só quando o duelo começa
              </p>
              <span className="mt-1 rounded-full border border-amber-600/60 bg-amber-950/40 px-3 py-1 font-mono text-sm font-black text-amber-200"
                data-testid="gb-invite-countdown">
                {restaConvite}s
              </span>
            </div>
            <div className="mt-4 flex gap-2 border-t border-purple-900/70 p-4">
              <button onClick={onDeclineInvite} data-testid="gb-invite-decline"
                className="flex flex-1 items-center justify-center gap-1.5 rounded-2xl border border-purple-700/70 py-3 text-xs font-black uppercase tracking-wide text-purple-200 transition-colors hover:border-rose-600 hover:text-rose-200">
                <X className="h-4 w-4" />recusar
              </button>
              <button onClick={onAcceptInvite} disabled={!saldoOk || travado}
                data-testid="gb-invite-accept"
                className="flex flex-[1.4] items-center justify-center gap-1.5 rounded-2xl bg-gradient-to-r from-orange-600 via-orange-500 to-amber-400 py-3 text-xs font-black uppercase tracking-wide text-[#1b0d02] shadow-[0_0_26px_rgba(255,107,0,.45)] transition-transform hover:scale-[1.02] disabled:opacity-40 disabled:hover:scale-100">
                <Check className="h-4 w-4" />{travado ? 'em manutenção' : !saldoOk ? 'sem saldo' : 'aceitar duelo'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export const GbMatchFx = ({ eu, rival }) => (
  <div className="fixed inset-0 z-[80] flex items-center justify-center bg-black/90" data-testid="gb-match-fx">
    <div className="flex w-full max-w-xl items-center justify-between gap-4 px-6">
      {[eu, rival].map((p, i) => (
        <div key={i} className={`flex flex-1 flex-col items-center gap-2 ${i === 0 ? 'animate-[slideL_.5s_ease-out]' : 'animate-[slideR_.5s_ease-out]'}`}>
          {p?.avatar
            ? <img src={p.avatar} alt="" className="h-20 w-20 rounded-full border-4 border-amber-400 object-cover shadow-[0_0_30px_rgba(251,191,36,.6)]" />
            : <span className="flex h-20 w-20 items-center justify-center rounded-full border-4 border-amber-400 bg-purple-900 text-3xl">🎃</span>}
          <p className="max-w-full truncate text-sm font-black text-amber-100">{p?.nickname || 'Adversário'}</p>
        </div>
      ))}
      <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
        <p className="animate-pulse text-5xl font-black text-orange-500 drop-shadow-[0_0_24px_rgba(255,107,0,.8)]">VS</p>
      </div>
    </div>
    <p className="absolute bottom-16 text-xs font-black uppercase tracking-[0.3em] text-amber-300">
      oponente encontrado · preparando a arena
    </p>
    <style>{`@keyframes slideL{from{transform:translateX(-60px);opacity:0}to{transform:none;opacity:1}}
      @keyframes slideR{from{transform:translateX(60px);opacity:0}to{transform:none;opacity:1}}`}</style>
  </div>
);
